import { render, staticRenderFns } from "./SimplePaginator.vue?vue&type=template&id=274b42a4&scoped=true"
import script from "./SimplePaginator.vue?vue&type=script&lang=js"
export * from "./SimplePaginator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274b42a4",
  null
  
)

export default component.exports